import { logEvent, logException } from "../helper/AppInsightsHelper";
import { configAxiosToken } from "../Utils/js-common";
import { ENDPOINTS } from "./ServiceConfig";

export async function updateUserLog(graphToken: string, loginToken: string) {
  return configAxiosToken(graphToken)
    .get("https://graph.microsoft.com/v1.0/me")
    .then((resp) => configAxiosToken(loginToken).post(ENDPOINTS.BASE_URL + "User/UpdateUserLog", { ...resp.data }))
    .then((response) => {
      logEvent("updateUserLog API call success", "Login Page", "User Logging Service Slicer");
      return response?.data;
    })
    .catch((error) => {
      logException("Login Page", "User Logging Service Slicer", "updateUserLog", error);
      return error;
    });
}

export async function fetchVerifyUser(token: string = "") {
  return configAxiosToken(token)
    .get<boolean>(ENDPOINTS.BASE_URL + "user/verifyuser")
    .then((response) => response.status === 200)
    .catch((error) => Promise.reject(new Error(error)));
}
